import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const SoundIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <g clipPath="url(#clip0_11577_11339)">
            <path
               d="M18.75 9.02312C18.75 5.28699 15.7266 2.25578 12 2.25578C8.27344 2.25578 5.25 5.28699 5.25 9.02312V17.2943C5.25 19.7851 7.26562 21.8059 9.75 21.8059C12.2344 21.8059 14.25 19.7851 14.25 17.2943C14.25 16.2745 14.7609 15.2923 15.6469 14.719C17.5172 13.5112 18.75 11.4105 18.75 9.02312ZM21 9.02312C21 12.2094 19.3547 15.0103 16.8656 16.6129C16.6359 16.7633 16.5 17.017 16.5 17.2943C16.5 21.0305 13.4766 24.0617 9.75 24.0617C6.02344 24.0617 3 21.0305 3 17.2943V9.02312C3 4.04161 7.03125 0 12 0C16.9688 0 21 4.04161 21 9.02312ZM9 9.02312V9.97243C9 10.1134 9.07969 10.245 9.20625 10.3108L9.8625 10.6398C10.7109 11.0674 11.2453 11.9368 11.2453 12.8861C11.2453 13.6334 10.9172 14.3383 10.3453 14.8177L8.59219 16.2839C8.11406 16.6834 7.40625 16.6176 7.00781 16.1382C6.60938 15.6589 6.675 14.9492 7.15312 14.5498L8.90625 13.0835C8.9625 13.0365 9 12.9613 9 12.8861C9 12.7875 8.94375 12.6982 8.85938 12.6559L8.20312 12.3269C7.3125 11.8804 6.75 10.9687 6.75 9.97243V9.02312C6.75 6.11411 9.09844 3.75963 12 3.75963C14.9016 3.75963 17.25 6.11411 17.25 9.02312V9.39909C17.25 10.0241 16.7484 10.527 16.125 10.527C15.5016 10.527 15 10.0241 15 9.39909V9.02312C15 7.36419 13.6547 6.01542 12 6.01542C10.3453 6.01542 9 7.36419 9 9.02312Z"
               fill="currentColor"
            />
         </g>
         <defs>
            <clipPath id="clip0_11577_11339">
               <rect
                  width="24"
                  height="24"
                  fill="white"
               />
            </clipPath>
         </defs>
      </svg>
   )
}

export default SoundIcon
